/**
 * Pagination contract.
 *
 * Every list endpoint is server-paginated without exception. The real legacy data has
 * 190k+ processed documents (spec §17); a single endpoint that forgets this is a
 * production outage, so the shape is shared rather than re-derived per module.
 */
import { z } from 'zod';
export const MAX_PAGE_SIZE = 200;
export const DEFAULT_PAGE_SIZE = 25;
export const sortDirectionSchema = z.enum(['asc', 'desc']);
export const pageQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
    sortBy: z.string().max(60).optional(),
    sortDir: sortDirectionSchema.default('desc'),
    /** Free-text search. What it searches is documented per endpoint. */
    q: z.string().trim().max(200).optional(),
});
export function buildPage(items, total, query) {
    const totalPages = Math.max(1, Math.ceil(total / query.pageSize));
    return {
        items,
        page: query.page,
        pageSize: query.pageSize,
        total,
        totalPages,
        hasNext: query.page < totalPages,
        hasPrevious: query.page > 1,
    };
}
/**
 * Guards against ORDER BY injection and against sorting by an unindexed column, which
 * at 190k rows is the difference between 20ms and a table scan.
 */
export function resolveSort(requested, allowed, fallback) {
    return allowed.includes(requested) ? requested : fallback;
}
export const dateRangeSchema = z
    .object({
    from: z.string().optional(),
    to: z.string().optional(),
})
    .refine((v) => !v.from || !v.to || v.from <= v.to, {
    message: 'The start of the range must not be after the end',
});
//# sourceMappingURL=pagination.js.map